import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '../../../models/user';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthenticationService } from '../../../services/authentication/authentication.service';
import { SidebarService } from '../../../services/sidebar/sidebar.service';



@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  sidebarWidth: number;
  currentUser: User;
  avatar: Blob;
  isDefaultAvatar: boolean = true;
  isSidebarOpen: boolean = false;

  userNavBar = {
    name: "",
    email: "",
    imageUrl: null
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private sidebarService: SidebarService,
    private sanitizer: DomSanitizer
  ) {
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    this.sidebarService.openSidebar.subscribe(open => this.isSidebarOpen = open);
    this.setUserDati();
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
    this.sidebarService.toggleSidebar(this.isSidebarOpen);
  }

  logout() {
    let token = JSON.parse(localStorage.getItem("currentUser"));
    let logoutBeService = this.authenticationService.logoutLog(token.token)
    logoutBeService.pipe().subscribe(
      (data: any) => {
        this.authenticationService.logout();
        this.router.navigate(['/login']);
      },
      (error) => { console.log("error ", error) }
    )
  }

  setUserDati() {
    if (this.currentUser) {
      this.userNavBar.email = this.currentUser.userBackend.email;
      if (this.currentUser.userGoogle) {
        if (this.currentUser.userGoogle.name != typeof undefined && this.currentUser.userGoogle.name != null) {
          this.userNavBar.name = this.currentUser.userGoogle.name;
        }
      }
    }
  }






}
